var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroidTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 58,
    viewBox: "0 0 70 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0833 40.5V49.25C32.0833 50.8542 30.7708 52.1667 29.1667 52.1667C27.5625 52.1667 26.25 50.8542 26.25 49.25V40.5H32.0833Z",
    fill: "#D9DBE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7513 40.5V49.25C43.7513 50.8542 42.4388 52.1667 40.8346 52.1667C39.2305 52.1667 37.918 50.8542 37.918 49.25V40.5H43.7513Z",
    fill: "#D9DBE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5846 20.0833V34.6667C49.5846 37.875 46.9596 40.5 43.7513 40.5H26.2513C23.043 40.5 20.418 37.875 20.418 34.6667V20.0833C20.418 16.875 23.043 14.25 26.2513 14.25H43.7513C46.9596 14.25 49.5846 16.875 49.5846 20.0833Z",
    fill: "#D9DBE9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 20.0833V31.75C14.5833 33.3541 13.2708 34.6666 11.6667 34.6666C10.0625 34.6666 8.75 33.3541 8.75 31.75V20.0833C8.75 18.4791 10.0625 17.1666 11.6667 17.1666C13.2708 17.1666 14.5833 18.4791 14.5833 20.0833Z",
    fill: "#D9DBE9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2513 20.0833V31.75C61.2513 33.3541 59.9388 34.6666 58.3346 34.6666C56.7305 34.6666 55.418 33.3541 55.418 31.75V20.0833C55.418 18.4791 56.7305 17.1666 58.3346 17.1666C59.9388 17.1666 61.2513 18.4791 61.2513 20.0833Z",
    fill: "#D9DBE9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9986 10.1667H41.9988C44.5654 10.1667 46.6654 8.06671 46.6654 5.50004C46.6654 -0.945793 41.4445 -6.16663 34.9987 -6.16663C28.5529 -6.16663 23.332 -0.945793 23.332 5.50004C23.332 8.06671 25.432 10.1667 27.9986 10.1667Z",
    fill: "#D9DBE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidTop);
export default __webpack_public_path__ + "static/media/android-top.0fe4a018f4aa0434c65b6469e827c35f.svg";
export { ForwardRef as ReactComponent };